import styles from "../../../../styles/patient-page-modules/Charts.module.css";
import { formatDate, formatNumber, convertUTCToLocal } from "../../../../utils/helper";

// Colors and ranges mirror the BP / Heart Rate legend in
// shared-modules/health-chart/HealthChartSummary.jsx (healthChart.module.css).
const LEGEND_COLORS = {
  hypotensive: "#3b82f6",
  normal: "#10b981",
  elevated: "#84cc16",
  stage1: "#f59e0b",
  stage2: "#ef4444",
  crisis: "#7f1d1d",
};

const LEGEND_LABELS = {
  hypotensive: "Hypotensive",
  normal: "Normal",
  elevated: "Elevated",
  stage1: "Stage 1 Hypertension",
  stage2: "Stage 2 Hypertension",
  crisis: "Hypertensive Crisis",
  bradycardia: "Bradycardia",
  tachycardia: "Tachycardia",
};

// Systolic: <90 | 90-119 | 120-129 | 130-139 | 140-180 | >180
const getSystolicCategory = (value) => {
  if (value < 90) return "hypotensive";
  if (value < 120) return "normal";
  if (value < 130) return "elevated";
  if (value < 140) return "stage1";
  if (value <= 180) return "stage2";
  return "crisis";
};

// Diastolic: <60 | 60-79 | 80-89 | 90-120 | >120 (no "Elevated" band for diastolic)
const getDiastolicCategory = (value) => {
  if (value < 60) return "hypotensive";
  if (value < 80) return "normal";
  if (value < 90) return "stage1";
  if (value <= 120) return "stage2";
  return "crisis";
};

// Heart rate: <60 Bradycardia | 60-100 Normal | >100 Tachycardia
const getHeartRateCategory = (value) => {
  if (value < 60) return "bradycardia";
  if (value <= 100) return "normal";
  return "tachycardia";
};

const HR_COLORS = {
  bradycardia: LEGEND_COLORS.stage1,
  normal: LEGEND_COLORS.normal,
  tachycardia: LEGEND_COLORS.stage2,
};

const renderMark = (value, category, color, unit) => (
  <div className={styles.condition}>
    {value !== null && value !== undefined && (
      <div
        className={styles.condition_mark}
        title={LEGEND_LABELS[category]}
        style={{ backgroundColor: color, borderColor: color }}
      ></div>
    )}{" "}
    {formatNumber("decimal", value)} {unit}
  </div>
);

export const bloodPressureColumns = [
  {
    key: "reading_dates",
    label: "Reading Dates",
    alignLeft: true,
    // SCRUM-989: the rows have no "reading_dates" field, so the sort arrows
    // need the date shown (date and time).
    sortField: "recorded_at",
    render: (reading) => convertUTCToLocal(reading.recorded_at),
  },
  {
    key: "systolic",
    label: "Systolic",
    render: (reading) => {
      const category = getSystolicCategory(Number(reading?.systolic));
      return renderMark(reading?.systolic, category, LEGEND_COLORS[category], "mm Hg");
    },
  },
  {
    key: "diastolic",
    label: "Diastolic",
    render: (reading) => {
      const category = getDiastolicCategory(Number(reading?.diastolic));
      return renderMark(reading?.diastolic, category, LEGEND_COLORS[category], "mm Hg");
    },
  },
  {
    key: "heart_rate",
    label: "Heart Rate",
    render: (reading) => {
      const category = getHeartRateCategory(Number(reading?.heart_rate));
      return renderMark(reading?.heart_rate, category, HR_COLORS[category], "bpm");
    },
  },
];
